import { render, staticRenderFns } from "./iqmassetwarningmodal.vue?vue&type=template&id=520ec4a3"
import script from "./iqmassetwarningmodal.vue?vue&type=script&lang=js"
export * from "./iqmassetwarningmodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports